import { createSlice } from '@reduxjs/toolkit';

const CAMP_CENTERS_KEY  = 'yk_camp_centers_cache';
const CLASS_CENTERS_KEY = 'yk_class_centers_cache';
const CACHE_TTL_MS      = 10 * 60 * 1000; // 10 minutes

const readCache = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return [];
    const { data, ts } = JSON.parse(raw);
    return (Date.now() - ts < CACHE_TTL_MS && Array.isArray(data)) ? data : [];
  } catch { return []; }
};

const writeCache = (key, data) => {
  try { sessionStorage.setItem(key, JSON.stringify({ data, ts: Date.now() })); } catch {}
};

const initialState = {
  classCenters: readCache(CLASS_CENTERS_KEY),
  campCenters:  readCache(CAMP_CENTERS_KEY),
  loading: false,
  error: null,
};

const centersListSlice = createSlice({
  name: 'centersList',
  initialState,
  reducers: {
    // Set class centers
    setClassCenters: (state, action) => {
      state.classCenters = action.payload;
      writeCache(CLASS_CENTERS_KEY, action.payload);
    },

    // Set camp centers
    setCampCenters: (state, action) => {
      state.campCenters = action.payload;
      writeCache(CAMP_CENTERS_KEY, action.payload);
    },

    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
    },

    // Clear all centers
    clearCenters: (state) => {
      state.classCenters = [];
      state.campCenters = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setClassCenters, setCampCenters, setLoading, setError, clearCenters } = centersListSlice.actions;
export default centersListSlice.reducer;
